import React from 'react';
import {
  FaCode, FaDatabase, FaTable, FaLaptopCode, FaChartBar,
  FaChartPie, FaEye, FaBrain, FaChartArea, FaTools,
} from 'react-icons/fa';
import { FaPython } from 'react-icons/fa6';
import SectionTitle from '../components/shared/SectionTitle';
import '../styles/skills.css';

const columns = [
  {
    title: 'Programming',
    icon: <FaCode />,
    type: 'icons',
    items: [
      { icon: <FaDatabase />,   name: 'SQL' },
      { icon: <FaPython />,     name: 'Python' },
      { icon: <FaChartArea />,  name: 'R' },
    ],
  },
  {
    title: 'Data Analytics Tools',
    icon: <FaTools />,
    type: 'icons',
    items: [
      { icon: <FaTable />,      name: 'Microsoft Excel' },
      { icon: <FaTable />,      name: 'Google Sheets' },
      { icon: <FaDatabase />,   name: 'Google BigQuery' },
      { icon: <FaLaptopCode />, name: 'VS Code' },
    ],
  },
  {
    title: 'Data Visualization',
    icon: <FaChartBar />,
    type: 'icons',
    items: [
      { icon: <FaChartPie />,  name: 'Power BI' },
      { icon: <FaChartBar />,  name: 'Tableau' },
      { icon: <FaEye />,       name: 'Looker Studio' },
    ],
  },
  {
    title: 'Analytic Methods',
    icon: <FaBrain />,
    type: 'bullets',
    items: [
      'Exploratory Data Analysis (EDA)',
      'Segmentation / Clustering',
      'Cohort Analysis',
      'Linear Regression',
      'Logistic Regression',
      'Statistics & A/B Testing',
      'ANOVA',
    ],
  },
];

function Skills() {
  return (
    <section className="skills section" id="skills">
      <div className="container">
        <SectionTitle label="What I Use" title="Tech Stack" />
        <div className="skills__columns">
          {columns.map((col) => (
            <div className="skills__col" key={col.title}>
              <div className="skills__col-header">
                <span className="skills__col-icon">{col.icon}</span>
                <h3>{col.title}</h3>
              </div>

              {col.type === 'icons' ? (
                col.items.map((item) => (
                  <div className="skills__item" key={item.name}>
                    <div className="skills__item-icon">{item.icon}</div>
                    <span className="skills__item-name">{item.name}</span>
                  </div>
                ))
              ) : (
                <ul className="skills__method-list">
                  {col.items.map((item) => <li key={item}>{item}</li>)}
                </ul>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Skills;